const MoveWindow = {
  data () {
    return {
      mixModalRef: null,
      mixInRectX: 0,
      mixInRectY: 0
    }
  },
  mounted () {
    this.mixInitMoveWindow()
  },
  methods: {
    mixInitMoveWindow () {
      return Promise
        .resolve()
        .then(() => {
          return this.mixGetModalRef()
        })
        .then((ref) => {
          this.mixModalRef = ref
          this.mixModalRef.style.position = 'absolute'
          this._initMoveEvents()
        })
    },
    mixGetModalRef () {
      return this.$refs.dialog.$el.firstElementChild
    },
    mixModalToCenter () {
      this.$nextTick(() => {
        const modalRect = this.mixModalRef.getBoundingClientRect()
        this.mixSetModalPosition((window.innerWidth - modalRect.width) / 2, 50)
      })
    },
    mixSetModalPosition (left, top) {
      this.mixModalRef.style.left = `${left}px`
      this.mixModalRef.style.top = `${top}px`
    },
    _moveModal (e) {
      let mouseX = e.clientX
      let mouseY = e.clientY
      let left = mouseX - this.mixInRectX
      let top = mouseY - this.mixInRectY
      this.mixSetModalPosition(left, top)
    },
    _initMoveEvents () {
      this.mixModalRef.addEventListener('mousedown', (e) => {
        const modalRect = this.mixModalRef.getBoundingClientRect()
        this.mixInRectX = e.clientX - modalRect.x
        this.mixInRectY = e.clientY - modalRect.y
        document.body.addEventListener('mousemove', this._moveModal)
      })
      this.mixModalRef.addEventListener('mouseup', (e) => {
        document.body.removeEventListener('mousemove', this._moveModal)
      })
    }
  }
}
export {
  MoveWindow
}
